import React, { useState } from "react";
// import SideBar from "../admincomponent/sidebar";
import SideBar from "../../admincomponent/Sidebar";
import Layout from "./layout";

function Dashboard() {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex bg-white">
      <div
        className={`transition-all ease-in-out z-10`}
        style={{ width: open ? "16%" : "8%" }}
      >
        <SideBar open={open} setOpen={setOpen} />
      </div>
      <div
        className={`ml-auto transition-all ease-in-out`}
        // className={`${
        //   open ? "w-11/12" : " w-screen"
        // } ml-auto transition-all ease-in-out`}
        style={{ width: open ? "90%" : "92%" }}
      >
        <Layout setOpen={open} open={setOpen} />
      </div>
    </div>
  );
}

export default Dashboard;
